import {
  retrieveAlertCenterChecks,
  AlertCenterCheckResponse,
  seriesAlertCenter,
  SeriesAlertCenterOkResponse
} from '@goldcast/api/backend';

import { formatFailedChecksForEntityItems } from '../utils';

const actions = {
  async getAlertCenterChecks({ commit }, eventId: string) {
    return new Promise((resolve, reject) => {
      retrieveAlertCenterChecks({
        id: eventId
      })
        .then((response: AlertCenterCheckResponse) => {
          commit('setAlertCenterChecks', response);
          commit('setFormattedEntityMappedAlerts', formatFailedChecksForEntityItems(response.failed_checks));
          resolve(response);
        })
        .catch(error => {
          commit('setAlertCenterChecks', {});
          reject(error);
        });
    });
  },
  async getSeriesAlertCenterChecks({ commit }, eventId: string) {
    return new Promise((resolve, reject) => {
      seriesAlertCenter({
        id: eventId
      })
        .then((response: SeriesAlertCenterOkResponse) => {
          commit('setAlertCenterChecks', response);
          resolve(response);
        })
        .catch(error => {
          commit('setAlertCenterChecks', {});
          reject(error);
        });
    });
  }
};

export default actions;
